import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

export default class extends Controller {
  static targets = ["money"];

  connect() {
    this.initializeMasks();
  }

  initializeMasks() {
    this.moneyTargets.forEach((element) => {
      IMask(element, {
        mask: "R$ num",
        blocks: {
          num: {
            mask: Number,
            thousandsSeparator: ".",
            radix: ",",
            scale: 2,
            padFractionalZeros: true,
            normalizeZeros: true,
            mapToRadix: ["."],
          },
        },
      });
    });
  }
}
